export const MODAL_NAME = 'privateOutcomeCall'
